import { render, staticRenderFns } from "./cardItemControl.vue?vue&type=template&id=18e940d9&scoped=true&"
import script from "./cardItemControl.vue?vue&type=script&lang=js&"
export * from "./cardItemControl.vue?vue&type=script&lang=js&"
import style0 from "./cardItemControl.vue?vue&type=style&index=0&id=18e940d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e940d9",
  null
  
)

export default component.exports